import React from "react";

function Header() {
    return (
        <header>
            <h1>Korbball App</h1>
        </header>
    );
}
export default Header;